<template>
    <div>
        <div class="h1">
        </div>
        <div style="position: absolute;
    top: 6.5rem;
	width: 100%;
	display: flex; 
	justify-content: center;
    z-index: 1;">
            <img @click="to_api()" style="margin-left:auto; margin-right:auto" src="../assets/imgs/213/按钮.png" alt="">
        </div>
    </div>
</template>
<!-- mounted() {
    this.adid = this.$route.query.adid
    this.creativeid = this.$route.query.creativeid
    this.creativetype = this.$route.query.creativetype
    this.clickid = this.$route.query.clickid
    this.code = this.$route.query.code
    if (this.$route.query.adid == undefined) {
        this.adid = null
    }
    if (this.$route.query.creativeid == undefined) {
        this.creativeid = null
    }
    if (this.$route.query.creativetype == undefined) {
        this.creativetype = null
    }
    if (this.$route.query.clickid == undefined) {
        this.clickid = null
    }
}, -->
<script>
import axios from "axios"
// import { testdata } from '@/api/userApi.js'
export default {
    data() {
        return {
            adid: "",
            creativeid: "",
            creativetype: "",
            clickid: ""
        }
    },
    mounted() {
        this.adid = this.$route.query.adid
        this.creativeid = this.$route.query.creativeid
        this.creativetype = this.$route.query.creativetype
        this.clickid = this.$route.query.clickid
		this.addEnter()
    },
    methods: {
		addEnter(){
			let data = {
			              code: this.$route.query.code,
			          }
		
			          axios({
			              method: "GET",
			              url: "https://dy01.txcfgl.net:24080/v1/clutter/dataEnter?livecode=ca_135"
			              // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
			          }).then(res => {
			          })
		},
        to_api() {
            let data = {
                adid: this.adid,
                creativeid: this.creativeid,
                creativetype: this.creativetype,
                clickid: this.clickid,
                code: this.$route.query.code,
            }
			setTimeout(() => {
				if(data.clickid!=undefined){
					var length=data.clickid.slice(46,76);
					window.location.href ="https://work.weixin.qq.com/ca/cawcdede4048ee86bf?customer_channel=ca_147_"+length
				}else{
					window.location.href ="https://work.weixin.qq.com/ca/cawcdede4048ee86bf?customer_channel=ca_147"
				}
			}, 300);
            axios({
                method: "GET",
                url: "https://dy01.txcfgl.net:24080/v1/clutter/save?"+"clickid=" + data.clickid + "&livecode=ca_135"
                // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
            }).then(ress => {
                
            })
            
        },
    },

}
</script>

<style>
.h1 {
    width: 100%;
    height: 12rem;
    background: url(../assets/imgs/213/背景.jpg);
    background-size: 100% 100%;
}

</style>